import { createWebHistory, createRouter } from 'vue-router';
import adminRoutes from './AdminRoutes';
import authRoutes from './authRoutes';
import formRoutes from './formRoutes';
import pageRoutes from './PageRoutes';
import store from '@/vuex/store';
import { hasPermission } from '@/utility/permissionUtility';

const routes = [
  {
    name: 'Admin',
    path: '/',
    component: () => import(/* webpackChunkName: "admin" */ '@/layout/withAdminLayout.vue'),
    children: [...adminRoutes],
    meta: { auth: false },
  },
  {
    name: 'Auth',
    path: '/auth',
    component: () => import(/* webpackChunkName: "auth" */ '@/layout/withAuthLayout.vue'),
    children: [...authRoutes],
    meta: { auth: true },
  },
  {
    name: 'Form',
    path: '/form',
    component: () => import(/* webpackChunkName: "register" */ '@/layout/withRegisterLayout.vue'),
    children: [...formRoutes],
    meta: { auth: true },
  },
  {
    name: 'Page',
    path: '/page',
    component: () => import(/* webpackChunkName: "page" */ '@/layout/withAuthLayout.vue'),
    children: [...pageRoutes],
    meta: { auth: true },
  }
];

const router = createRouter({
  history: createWebHistory(
    process.env.NODE_ENV === 'production'
      ? process.env.VUE_APP_SUB_ROUTE
        ? process.env.VUE_APP_SUB_ROUTE
        : process.env.BASE_URL
      : process.env.BASE_URL,
  ),
  linkExactActiveClass: 'active',
  routes,
});

const routesWithouAuth = [
  'register',
  'terms-of-service',
  'privacy-policy',
  'confirm-email'
];

router.beforeEach((to, from, next) => {
  // La marca del cliente la guarda el layout en localStorage al cargarla; aqui
  // solo se lee. Sin eso el titulo de la pestana decia 'ProyectX CRM' aunque el
  // cliente tuviera la suya, que contradecia el resto de la pantalla.
  let marca = 'CRM ProyectX';
  try {
    marca = localStorage.getItem('brandName') || marca;
  } catch (e) {
    // Navegador sin almacenamiento: se queda la marca por defecto.
  }
  document.title = to.meta.title ? `${to.meta.title} · ${marca}` : marca;

  if (to.meta.auth && store.state.auth.login && !routesWithouAuth.includes(to.name)) {
    next({ to: '/app/dashboard' });
  } else if (!to.meta.auth && !store.state.auth.login) {
    next({ name: 'login' });
  } else {
    const requiredPermission = to.meta.permission;
    
    if (requiredPermission && !hasPermission(requiredPermission)) {
      next({ name: 'dashboard' });
    }

    next();
  }
});

export default router;
